import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Bell = createSvgIcon(
  <path d="M8.625 3.375c0 .172.013.34.038.506A6.748 6.748 0 0 0 5.25 9.75v3.334L3 15.709v4.541h18v-4.541l-2.25-2.625V9.75a6.748 6.748 0 0 0-3.413-5.869 3.375 3.375 0 1 0-6.712-.506ZM12 2.25c.522 0 .96.355 1.088.837a6.8 6.8 0 0 0-2.176 0A1.126 1.126 0 0 1 12 2.25Zm0 3a4.5 4.5 0 0 1 4.5 4.5v4.166l2.25 2.625V18H5.25v-1.459l2.25-2.625V9.75a4.5 4.5 0 0 1 4.5-4.5ZM12 24a2.25 2.25 0 0 0 2.25-2.25h-4.5A2.25 2.25 0 0 0 12 24Z" />,
  'Bell'
);

export { Bell };
